import React from 'react'
import { cfLogo } from '../../assets'
import { signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import { auth } from "../../firebase";
import { getCookie } from "../../helper";
import { useSelector } from 'react-redux';
import { ToastContainer } from "react-toastify";
import { handleToast } from "../../helper";
import { userLogout } from '../../services'
import { useNavigate } from 'react-router-dom';
import { setLogInUser, selectLogInUsername } from '../../common/authenticateDashboard/authSlice';
const passwordDefaultObj= {
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
}

const ChangePassword = () => {

  const user = useSelector(selectLogInUsername);
  console.log("user in ChangePassword", user);
  const [password, setPassword] = React.useState(passwordDefaultObj)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(null)
  const navigate =  useNavigate()

  async function handleChangePassword(e) {
    // react synthentic event to prevent default
    e.preventDefault();
    try {
      setLoading(true)
      // validate email and password
      if (!password.oldPassword || !password.newPassword || !password.confirmPassword) return setError('Please enter all fields');
      if (password.newPassword !== password.confirmPassword) return setError('Password does not match');

      // sign in user
      const signin = await signInWithEmailAndPassword(auth, user, password.oldPassword);
      if (signin) {
        updatePassword(auth.currentUser, password.newPassword).then(() => {
          // show success message
          handleToast("success", "Password changed successfully!");
          // reset form
          setTimeout(() => {
            userLogout();
            // navigate(0)
            navigate('/')
          }, 2000)
          return setPassword(passwordDefaultObj);
        })
      }
    } catch (error) {
      console.log(error)
      return setError('Invalid Credential');
    } finally {
      // stop loading
      setLoading(false)
    }
  }

  function handleOldPassword(e) {
    setPassword(prev => prev = ({ ...prev, oldPassword: e.target.value }));
    if (error) setError(null);
  }

  function handleNewPassword(e) {
    setPassword(prev => prev = ({ ...prev, newPassword: e.target.value }));
    if (error) setError(null);
  }

  function handleConfirmPassword(e) {
    if (error) setError(null);
    setPassword(prev => prev = ({ ...prev, confirmPassword: e.target.value }));
    if (password.newPassword.length < password.confirmPassword.length || (password.newPassword.length === password.confirmPassword.length && password.newPassword !== password.confirmPassword)) {
      return setError('Password does not match');
    }
  }

  return (
    <section className="login__page  bg-neutral-200 dark:bg-neutral-700 flex-grow pt-5">
      <ToastContainer />
      <div className="container p-4 sm:p-10 mx-auto text-neutral-800 dark:text-neutral-200 flex items-center justify-center">
        <div className="block rounded-lg bg-white shadow-lg dark:bg-neutral-800">
          <div className="md:px-12">
            <div className="mx-6 py-12">
              {/* <!--Logo--> */}
              <div className="text-center">
                <img
                  className="mx-auto w-48 sm:w-64 md:w-80 mb-3"
                  src={cfLogo}
                  alt="logo" />
              </div>

              <form>
                <p className="mb-4 text-center">Change your account password</p>
                {/* <!--Old password input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input onChange={handleOldPassword} value={password.oldPassword}
                    type="password"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full border-color bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0 "
                    id="exampleFormControlInput1"
                    placeholder="Old Password" />
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-white peer-focus:dark:bg-neutral-800 ${password.oldPassword === '' ? '' : '-translate-y-[0.9rem] scale-[0.8] bg-neutral-50'}`}
                  >Old Password*
                  </label>
                </div>

                {/* <!--New Password input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input onChange={handleNewPassword} value={password.newPassword}
                    type="password"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full border-color bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
                    id="exampleFormControlInput11"
                    placeholder="New Password" />
                  <label
                    htmlFor="exampleFormControlInput11"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-white peer-focus:dark:bg-neutral-800 ${password.newPassword === '' ? '' : '-translate-y-[0.9rem] scale-[0.8] bg-neutral-50'}`}
                  >New Password*
                  </label>
                </div>

                {/* <!--Confirm Password input--> */}
                <div className="relative mb-4" data-te-input-wrapper-init>
                  <input onChange={handleConfirmPassword}  value={password.confirmPassword}
                    type="password"
                    autoComplete="off"
                    className="peer block min-h-[auto] w-full border-color bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:placeholder:text-neutral-200 [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
                    id="exampleFormControlInput11"
                    placeholder="Confirm Password" />
                  <label
                    htmlFor="exampleFormControlInput11"
                    className={`pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-200 dark:peer-focus:text-primary peer-focus:bg-white peer-focus:dark:bg-neutral-800 ${password.confirmPassword === '' ? '' : '-translate-y-[0.9rem] scale-[0.8] bg-neutral-50'}`}
                  >Confirm Password*
                  </label>
                </div>

                {/* <!--Submit button--> */}
                <div className="pb-1 pt-1 text-center">
                  <button onClick={handleChangePassword}
                    className={`mb-3 inline-block w-full rounded px-6 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_rgba(0,0,0,0.2)] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:outline-none focus:ring-0 active:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] ${!loading && 'pb-2 pt-2.5'}`}
                    type="submit"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    style={{
                      background: 'linear-gradient(to right, rgb(190 49 199), rgb(170 46 226), rgb(91 146 245), rgb(50 197 255))',
                    }}>
                    {/* loading spinner svg */}
                    {loading ? (
                      <svg className='mx-auto bg-transparent' width="30px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <circle cx="50" cy="50" r="0" fill="none" stroke="#ffffff" strokeWidth="2">
                          <animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>
                          <animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>
                        </circle><circle cx="50" cy="50" r="0" fill="none" stroke="#ffffff" strokeWidth="2">
                          <animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.5s"></animate>
                          <animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.5s"></animate>
                        </circle>
                      </svg>) : (
                      <span>Change Password</span>
                    )}
                  </button>
                </div>

                {/* error message */}
                <div className="text-center max-w-xs">
                  <p className="text-xs text-red-500">{error}</p>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ChangePassword